<template>
  <!--==================
    component for update user profile details (admin, operator)
    ===============-->

  <div class="col pb-20 pt-20">
    <div v-if="form" class="d-md-flex justify-content-between profile-info">
      <!-- left side box -->
      <div class="col-md-4 content-box mb-3">
        <div class="profile-info-top text-center">
          <img v-if="form.banner" class="profile-info-banner" :src="form.banner" />
          <img v-if="!form.banner" class="profile-info-banner" src="@/assets/images/user_banner.jpg" />

          <div class="profile-info-pic">
            <img v-if="form.logo" class="profile-info-logo" :src="form.logo" />
            <img v-if="!form.logo" class="profile-info-logo" src="@/assets/images/user_logo.jpg" />
          </div>
        </div>

        <div class="mt-4 text-center">
          <h3 class="font-weight-bold">{{ companyName }}</h3>
          <p class="text-secondary">
            Account status:
            <span :class="form.status == 'active' ? 'text-success' : 'text-danger'">●</span>
            <em>{{ form.status }}</em>
          </p>
        </div>

        <hr />

        <!-- tab menu -->
        <ul id="form-tab" class="list-group">
          <button @click="formTabButton($event)" form-tab="basic" class="list-group-item text-left active">
            Basic Information
          </button>
          <button @click="formTabButton($event)" form-tab="description" class="list-group-item text-left">
            Company Description
          </button>
          <button @click="formTabButton($event)" form-tab="logo-banner" class="list-group-item text-left">
            Logo and Company Photo
          </button>
          <button @click="formTabButton($event)" form-tab="company-doc" class="list-group-item text-left">
            Company Documents
          </button>
          <button
            v-if="user.role == 'admin'"
            @click="formTabButton($event)"
            form-tab="note-admin"
            class="list-group-item text-left"
          >
            Note by Admin
          </button>
        </ul>
      </div>

      <!-- right side box -->
      <div class="col content-box mb-3 ml-md-4">
        <!-- basic info form -->
        <div v-if="formShow == 'basic'">
          <h2><strong>Basic Information</strong></h2>
          <form class="my-4" @submit.prevent="updateBasicInfo" ref="basicForm">
            <input type="hidden" name="id" :value="form.id" />

            <div class="my-4">
              <div class="form-group">
                <label>Company Name:</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  name="companyName"
                  v-model="form.companyName"
                  @input="$v.form.companyName.$touch()"
                />
                <span class="text-danger" v-if="$v.form.companyName.$dirty && !$v.form.companyName.required">
                  &nbsp; This field is required
                </span>
              </div>

              <div class="form-group">
                <label>Company Email:</label>
                <input
                  class="form-control form-control-sm"
                  type="email"
                  name="username"
                  v-model="form.username"
                  @input="$v.form.username.$touch()"
                />
                <span class="text-danger" v-if="$v.form.username.$dirty && !$v.form.username.required">
                  &nbsp; This field is required
                </span>
              </div>

              <div class="form-group">
                <label>Company Phone:</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  name="phoneNo"
                  v-model="form.phoneNo"
                  placeholder="eg.255XXXXXXXXX"
                  @input="$v.form.phoneNo.$touch()"
                />
                <span
                  class="text-danger"
                  v-if="
                    ($v.form.phoneNo.$dirty && !$v.form.phoneNo.numeric) ||
                    ($v.form.phoneNo.$dirty && !$v.form.phoneNo.minLength) ||
                    ($v.form.phoneNo.$dirty && !$v.form.phoneNo.maxLength)
                  "
                >
                  &nbsp; Enter a valid phone number
                </span>
              </div>

              <div class="form-group">
                <label>No. Of Staff:</label>
                <input
                  class="form-control form-control-sm"
                  type="number"
                  name="noOfStaff"
                  v-model="form.noOfStaff"
                  @input="$v.form.noOfStaff.$touch()"
                />
                <span class="text-danger" v-if="$v.form.noOfStaff.$dirty && !$v.form.noOfStaff.required">
                  &nbsp; This field is required
                </span>
              </div>

              <div class="form-group">
                <label>Company Office Location:</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  name="officeLocation"
                  v-model="form.officeLocation"
                />
              </div>

              <div class="form-group">
                <label>Company Contact Person:</label>
                <input class="form-control form-control-sm" type="text" name="personName" v-model="form.personName" />
              </div>

              <div class="form-group">
                <label>Company Address:</label>
                <input class="form-control form-control-sm" type="text" name="address" v-model="form.address" />
              </div>

              <div class="form-group">
                <label>Company Tour Type:</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  name="tourType"
                  v-model="form.tourType"
                  @input="$v.form.tourType.$touch()"
                />
                <span class="text-danger" v-if="$v.form.tourType.$dirty && !$v.form.tourType.required">
                  &nbsp; This field is required
                </span>
              </div>

              <div class="form-group">
                <label>Company Website Url:</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  name="websiteUrl"
                  v-model="form.websiteUrl"
                  @input="$v.form.websiteUrl.$touch()"
                />
                <span class="text-danger" v-if="$v.form.websiteUrl.$dirty && !$v.form.websiteUrl.urlRegex">
                  &nbsp; The website url should start with https:// or http://
                </span>
              </div>
            </div>

            <div class="form-group text-center mt-6">
              <button
                class="btn btn-sm btn-success col-md-6"
                type="submit"
                :disabled="submitForm.basicForm || $v.form.$invalid"
              >
                <span v-if="!submitForm.basicForm">UPDATE</span>
                <span v-if="submitForm.basicForm" class="ml-2">Updatting...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- company description -->
        <div v-if="formShow == 'description'">
          <h2><strong>Company Description</strong></h2>
          <form class="my-4" @submit.prevent="updateDescription" ref="descriptionForm">
            <input type="hidden" name="id" :value="form.id" />

            <div class="form-row">
              <div class="form-group col">
                <label>Mission:</label>
                <textarea
                  v-model="form.mission"
                  class="form-control form-control-sm"
                  rows="4"
                  name="mission"
                  @input="$v.form.mission.$touch()"
                ></textarea>
                <span class="text-danger" v-if="$v.form.mission.$dirty && !$v.form.mission.required">
                  &nbsp; This field is required
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>Vision:</label>
                <textarea
                  v-model="form.vision"
                  @input="$v.form.vision.$touch()"
                  class="form-control form-control-sm"
                  rows="4"
                  name="vision"
                ></textarea>
                <span class="text-danger" v-if="$v.form.vision.$dirty && !$v.form.vision.required">
                  &nbsp; This field is required
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label>About Us:</label>
                <vue-editor v-model="form.description" @input="$v.form.description.$touch()"></vue-editor>
                <!-- <ckeditor
                  v-model="form.description"
                  @input="$v.form.description.$touch()"
                  :config="CKE_config"
                ></ckeditor> -->
                <span class="text-danger" v-if="$v.form.description.$dirty && !$v.form.description.required">
                  &nbsp; This field is required
                </span>
              </div>
            </div>

            <div class="form-group text-center mt-6">
              <button
                class="btn btn-sm btn-success col-md-6"
                type="submit"
                :disabled="submitForm.descriptionForm || $v.form.$invalid"
              >
                <span v-if="!submitForm.descriptionForm">UPDATE</span>
                <span v-if="submitForm.descriptionForm" class="ml-2">Updatting...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- company logo and banner -->
        <div v-if="formShow == 'logo-banner'">
          <h2><strong>Logo and Company Photo</strong></h2>
          <form class="my-4" @submit.prevent="updateLogoBanner">
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-row mt-4 align-items-center">
                  <div class="form-group col-md-6">
                    <img v-if="form.logo" id="logo-preview" :src="form.logo" class="img-thumbnail" />
                    <img
                      v-if="!form.logo"
                      id="logo-preview"
                      src="@/assets/images/user_logo.jpg"
                      class="img-thumbnail"
                    />
                  </div>
                  <div class="upload-box mx-4">
                    <div class="form-file btn btn-default">
                      <i class="icofont-upload-alt"></i> upload file
                      <input
                        id="file-logo"
                        @change="photoPreview($event)"
                        type="file"
                        name="logo"
                        accept=".jpg,.png"
                        data-preview="logo-preview"
                      />
                    </div>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.logo">&nbsp; {{ errors.logo }}</span>
              </div>

              <div class="col-md-6">
                <div class="form-row mt-4 align-items-center">
                  <div class="form-group col-md-6">
                    <img v-if="form.banner" id="banner-preview" :src="form.banner" class="img-thumbnail" />
                    <img
                      v-if="!form.banner"
                      id="banner-preview"
                      src="@/assets/images/user_banner.jpg"
                      class="img-thumbnail"
                    />
                  </div>
                  <div class="upload-box mx-4">
                    <div class="form-file btn btn-default">
                      <i class="icofont-upload-alt"></i> upload file
                      <input
                        id="file-banner"
                        @change="photoPreview($event)"
                        type="file"
                        name="banner"
                        accept=".jpg,.png"
                        data-preview="banner-preview"
                      />
                    </div>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.banner">&nbsp; {{ errors.banner }}</span>
              </div>
            </div>

            <div class="form-group text-center mt-6">
              <button
                class="btn btn-sm btn-success col-md-6"
                type="submit"
                :disabled="submitForm.bannerForm || errors.logo || errors.banner"
              >
                <span v-if="!submitForm.bannerForm">UPDATE</span>
                <span v-if="submitForm.bannerForm" class="ml-2">Updatting...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- company documents -->
        <div v-if="formShow == 'company-doc'">
          <h2><strong>Company Documents</strong></h2>
          <div class="documents col">
            <div v-for="doc in form.documents" class="document" :key="doc.id">
              <div class="document-body" @contextmenu.prevent.stop="docContextMenu($event, doc)">
                <i v-if="imageFileIcon(doc.filepath)" class="icofont-file-jpg text-success"></i>
                <i v-if="pdfFileIcon(doc.filepath)" class="icofont-file-pdf text-success"></i>
              </div>
              <div class="document-footer">
                <span class="document-name" :title="doc.title">{{ doc.title }}</span>
                <span class="document-description">{{ documentSize(doc.filesize) }}</span>
              </div>
            </div>
          </div>
          <vue-simple-context-menu
            :elementId="'doc-context-menu'"
            :options="docMenuOptions"
            :ref="'companyDocContextMenu'"
            @option-clicked="docOptionClicked"
          />

          <form id="company-doc-form" class="my-4" @submit.prevent="updateCompanyDoc">
            <hr />
            <h4 class="mx-4">Add new document</h4>
            <div class="col">
              <div class="d-flex align-items-center">
                <div class="col-md-4 mx-4">
                  <div class="upload-box mb-3">
                    <div class="form-file btn btn-default w-100">
                      <i class="icofont-upload-alt"></i> upload file
                      <input id="file-doc" @change="setDocumentFileName($event)" type="file" name="document" />
                    </div>
                  </div>
                  <span class="text-info" v-if="documentFileName">&nbsp; {{ documentFileName }}</span>
                </div>

                <div class="form-group col-6 align-self-start">
                  <select id="file-doc-type" @change="documentType($event)" class="form-control">
                    <option value="">---- select document type ----</option>
                    <option v-for="doc in documentTypeList" :key="doc.id" :value="doc.name">
                      {{ doc.name }} ({{ doc.description }})
                    </option>
                    <option value="other">OTHER REWARD/CERTIFICATE (PDF or IMAGE)</option>
                  </select>
                  <input
                    v-if="otherDocType"
                    class="form-control form-control-sm mt-2"
                    type="text"
                    id="other-doc-type"
                    placeholder="document name"
                  />
                </div>
              </div>

              <span class="ml-4 text-danger" v-if="errors.document || errors.documentType || errors.otherDocType">
                &nbsp; please fill required field and upload required file format.
              </span>
            </div>

            <div class="form-group text-center mt-6">
              <button
                class="btn btn-sm btn-success col-md-6"
                type="submit"
                :disabled="submitForm.companyDocForm || errors.document || errors.documentType || errors.otherDocType"
              >
                <span v-if="!submitForm.companyDocForm">UPLOAD</span>
                <span v-if="submitForm.companyDocForm" class="ml-2">uploading...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- notify by admin -->
        <div v-if="formShow == 'note-admin'">
          <h2>
            <strong>Recommended Message<span class="badge badge-secondary">Admin</span></strong>
          </h2>
          <form class="my-4" @submit.prevent="updateMessage" ref="descriptionForm">
            <input type="hidden" name="id" :value="form.id" />

            <div class="form-row">
              <div class="form-group col">
                <label>Message:</label>
                <textarea class="form-control form-control-sm" rows="10" name="mesasge"></textarea>
              </div>
            </div>

            <div class="form-group text-center mt-6">
              <button class="btn btn-sm btn-success col-md-6" type="submit">
                <span v-if="!submitForm.descriptionForm">UPDATE</span>
                <span v-if="submitForm.descriptionForm" class="ml-2">Updatting...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

.vue-simple-context-menu {
  position: fixed;
  min-width: 132px;
  padding: 10px 0;
  background-color: #fbfbfb;
}
.vue-simple-context-menu__item:hover {
  background-color: #fe415a;
}
</style>

<script>
import { pagePreventLeave, pageLeave, formatBytes } from "@/assets/js/custom-function";
import $ from "jquery";
import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import { urlRegex } from "@/validator";
import VueSimpleContextMenu from "vue-simple-context-menu";
import { VueEditor } from "vue2-editor";

export default {
  name: "UserSetting",

  components: {
    "vue-simple-context-menu": VueSimpleContextMenu,
    VueEditor,
  },

  data() {
    return {
      formShow: "basic",
      companyName: "",
      documentFileName: "",
      otherDocType: false,
      errors: {},
      submitForm: {
        basicForm: false,
        descriptionForm: false,
        bannerForm: false,
        companyDocForm: false,
      },
      CKE_config: {
        height: 400,
        removeButtons: "About",
        extraPlugins: "justify",
      },
      docMenuOptions: [
        {
          name: "Open",
          slug: "open",
        },
        {
          name: "Delete",
          slug: "delete",
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["operator", "documentTypes", "user"]),

    form() {
      return this.operator;
    },

    documentTypeList() {
      return this.documentTypes;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      pagePreventLeave();

      await this.fetchOperator(this.$route.params.id);
      await this.fetchDocumentTypes();

      this.hideBarLoading();
    });
  },

  validations() {
    if (this.formShow === "basic") {
      // validate basic info inputs
      return {
        form: {
          companyName: { required },
          username: { required },
          tourType: { required },
          websiteUrl: { urlRegex },
          noOfStaff: { required },
          phoneNo: { numeric, minLength: minLength(12), maxLength: maxLength(12) },
        },
      };
    } else if (this.formShow === "description") {
      // validate description inputs
      return {
        form: {
          mission: { required },
          vision: { required },
          description: { required },
        },
      };
    } else {
      return { form: {} };
    }
  },

  methods: {
    ...mapActions([
      "fetchOperator",
      "updateOperatorBasicInfo",
      "updateOperatorDescription",
      "updateOperatorLogoBanner",
      "updateOperatorCompanyDoc",
      "deleteOperatorCompanyDoc",
      "fetchDocumentTypes",
      "hideBarLoading",
      "showSpinnerLoading",
      "hideSpinnerLoading",
    ]),

    async updateCompanyDoc() {
      const formData = new FormData();
      let fileDocType = $("#file-doc-type").val();
      const fileDocument = $("#file-doc")[0].files[0];
      if ($("#other-doc-type").val()) {
        fileDocType = $("#other-doc-type").val().toUpperCase();
      }

      formData.append("document", fileDocument);
      formData.append("documentType", fileDocType);

      if (formData.get("document").size && formData.get("documentType")) {
        this.showSpinnerLoading();
        this.submitForm.companyDocForm = true;

        await this.updateOperatorCompanyDoc({ id: this.form.id, formData })
          .then((res) => {
            pageLeave();
            $("#company-doc-form")[0].reset();
            $.alert("uploaded successfull.");
            this.hideSpinnerLoading();
            this.documentFileName = false;
            this.submitForm.companyDocForm = false;
            this.fetchOperator(this.$route.params.id);
            // console.log(res.data)
          })
          .catch((error) => {
            $.alert("submision failed!");
            this.hideSpinnerLoading();
            this.submitForm.companyDocForm = false;
          });
      }
    },

    async updateLogoBanner() {
      this.showSpinnerLoading();
      this.submitForm.bannerForm = true;

      const formData = new FormData();
      const fileLogo = $("#file-logo")[0].files[0];
      const fileBanner = $("#file-banner")[0].files[0];

      formData.append("logo", fileLogo);
      formData.append("banner", fileBanner);

      await this.updateOperatorLogoBanner({ id: this.form.id, formData })
        .then((res) => {
          pageLeave();
          $.alert("updated successfull.");
          this.hideSpinnerLoading();
          this.submitForm.bannerForm = false;
          // console.log(res.data)
        })
        .catch((error) => {
          $.alert("submision failed!");
          this.hideSpinnerLoading();
          this.submitForm.bannerForm = false;
        });
    },

    updateMessage() {},

    async updateDescription() {
      this.showSpinnerLoading();
      this.submitForm.descriptionForm = true;

      const formData = new FormData(this.$refs.descriptionForm);
      formData.append("description", this.form.description);
      const data = Object.fromEntries(formData.entries());

      data.id = parseInt(data.id);

      // replace empty string with null
      const submitData = Object.keys(data).reduce((acc, key) => {
        acc[key] = data[key] === "" ? null : data[key];
        return acc;
      }, {});

      await this.updateOperatorDescription(submitData)
        .then(() => {
          $.alert("updated successfull.");
          pageLeave();
          this.hideSpinnerLoading();
          this.fetchOperator(this.$route.params.id);
          this.submitForm.descriptionForm = false;
        })
        .catch((error) => {
          $.alert("submision failed!");
          this.hideSpinnerLoading();
          this.submitForm.descriptionForm = false;
        });
    },

    async updateBasicInfo() {
      this.showSpinnerLoading();
      this.submitForm.basicForm = true;

      const formData = new FormData(this.$refs.basicForm);
      const data = Object.fromEntries(formData.entries());

      data.id = parseInt(data.id);
      data.noOfStaff = parseInt(data.noOfStaff);

      // replace empty string with null
      const submitData = Object.keys(data).reduce((acc, key) => {
        acc[key] = data[key] === "" ? null : data[key];
        return acc;
      }, {});

      await this.updateOperatorBasicInfo(submitData)
        .then(() => {
          $.alert("updated successfull.");
          pageLeave();
          this.hideSpinnerLoading();
          this.fetchOperator(this.$route.params.id);
          this.submitForm.basicForm = false;
        })
        .catch((error) => {
          $.alert("submision failed!");
          this.hideSpinnerLoading();
          this.submitForm.basicForm = false;
        });
    },

    setDocumentFileName(event) {
      let filename = $(event.target)
        .val()
        .replace(/C:\\fakepath\\/i, "");

      this.documentFileName = filename;
    },

    documentType(event) {
      let docType = $(event.target).val();

      if (docType == "other") {
        this.otherDocType = true;
      } else {
        this.otherDocType = false;
      }
    },

    openDocument(filepath) {
      window.open(filepath, "_blank");
    },

    deleteDocument(docId, docType) {
      var dD = this;

      $.confirm({
        title: "",
        content: 'Are you sure want to delete "' + docType + '" document',
        buttons: {
          confirm: async () => {
            dD.showSpinnerLoading();

            await dD.deleteOperatorCompanyDoc(docId).then(() => {
              $.alert("deleted successfull.");
              dD.fetchOperator(dD.$route.params.id);
              dD.hideSpinnerLoading();
            });
          },
          cancel: () => {},
        },
      });
    },

    photoPreview(event) {
      this.errors = {};
      const pP = this;
      const imageField = event.target.getAttribute("name");
      const imageFile = event.target.files[0];

      if (imageFile) {
        const reader = new FileReader();
        const img = new Image();
        const fileSize = imageFile.size / 1024 / 1024; // in MiB

        reader.onload = function () {
          let imgWidth = null;
          let imgHeight = null;

          img.src = reader.result;
          img.onload = function () {
            imgWidth = this.width;
            imgHeight = this.height;

            // image validations
            if (imageField === "logo") {
              pP.form.logo = reader.result;

              if (fileSize > 1) {
                pP.errors.logo = "File too large.";
              } else if (imgWidth != 200 || imgHeight != 200) {
                pP.errors.logo = "Image size must be 200x200.";
              }
            } else {
              pP.form.banner = reader.result;

              if (fileSize > 1) {
                pP.errors.banner = "File too large";
              } else if (imgWidth != 330 || imgHeight != 220) {
                pP.errors.banner = "Image size must be 330x220.";
              }
            }
          };
        };
        reader.readAsDataURL(imageFile);
      } else {
        if (imageField === "logo") {
          this.form.logo = "";
        } else {
          this.form.banner = "";
        }
      }
    },

    imageFileIcon(file) {
      var ext = file.split(".").pop();
      var validExt = ["png", "jpg", "jpeg"];

      return validExt.includes(ext.toLowerCase());
    },

    pdfFileIcon(file) {
      var ext = file.split(".").pop();
      var validExt = ["pdf"];

      return validExt.includes(ext.toLowerCase());
    },

    documentSize(fileSize) {
      return formatBytes(fileSize);
    },

    formTabButton(event) {
      let formTab = event.target.getAttribute("form-tab");

      $("#form-tab .list-group-item").removeClass("active");
      $(event.target).addClass("active");

      this.formShow = formTab;
    },

    docContextMenu(event, doc) {
      this.$refs.companyDocContextMenu.showMenu(event, doc);
    },

    docOptionClicked(event) {
      if (event.option.slug === "delete") {
        this.deleteDocument(event.item.id, event.item.title);
      } else if (event.option.slug === "open") {
        this.openDocument(event.item.filepath);
      }
    },
  },
};
</script>
